/*
 * Tua História — configurador de almofadas personalizadas.
 * Usado pela secção "configurador-almofada" do tema e pelo protótipo local.
 *
 * Cada configurador é um elemento [data-th-almofada] com um
 * <script type="application/json"> lá dentro (ver a secção Liquid).
 */

const PADRAO = {
  servidor: 'http://localhost:8000',
  modulo3d: './almofada-3d.js',
  lingua: 'pt',                  // pt | es | de (vem de request.locale na secção)
  maxMb: 15,
  margemCm: 1.5,
  diasProducao: 0,              // 0 = não mostra o prazo
  depoisDeAdicionar: 'carrinho', // carrinho | gaveta | ficar
  modoTeste: false,
  tamanhos: [],                  // [{ etiqueta, cm, varianteId, preco, disponivel, padrao }]
  textos: {},                    // textos alterados no editor de temas (só os preenchidos)
};

// Textos por língua. Os campos preenchidos no editor de temas sobrepõem-se a estes.
const TEXTOS = {
  pt: {
    titulo: 'Cria a tua almofada',
    subtitulo: 'Carrega uma foto e vê a tua almofada em 3D, com a forma de quem mais gostas.',
    uploadAjuda: 'JPG, PNG ou HEIC · até 15 MB',
    uploadBotao: 'Carrega a tua foto',
    uploadArrastar: 'ou arrasta-a para aqui',
    dica: 'Dica: escolhe uma foto nítida, com boa luz e com a pessoa ou o animal inteiro na imagem.',
    privacidade: 'A tua foto é usada só para criar a almofada e é apagada se não fizeres a encomenda ou assim que a receberes.',
    privacidadeLink: 'Política de privacidade',
    aGerarTitulo: 'A preparar a tua almofada…',
    aGerarMensagens: 'A recortar a tua foto|A desenhar a forma da almofada|A acrescentar a margem branca|A encher de fofura|Quase pronta',
    aGerarAjuda: 'Isto pode demorar até 30 segundos.',
    arrastar: 'Arrasta para rodar',
    medidas: 'Medidas aproximadas: {largura} × {altura} cm',
    tamanhoTitulo: 'Escolhe o tamanho',
    mudarImagem: 'Mudar imagem',
    adicionar: 'Adicionar ao carrinho',
    aAdicionar: 'A adicionar…',
    adicionado: 'Adicionado ao carrinho ✓',
    criarOutra: 'Criar outra almofada',
    descontoOutra: 'Junta a 2.ª e poupas 10% em cada',
    desconto3: 'Junta a 3.ª e poupas 15% em cada',
    desconto4: 'Junta a 4.ª e poupas 25% em cada',
    verCarrinho: 'Ver carrinho',
    semImagem: 'Carrega uma foto para continuar',
    esgotado: 'Esgotado',
    aviso: 'A pré-visualização 3D é ilustrativa. A nossa equipa revê cada foto antes de produzir a tua almofada.',
    prazo: 'Feita por encomenda · enviada entre 3 a 4 dias',
    prazoLink: 'Política de envio',
    personalizado: 'Por ser um produto personalizado, feito à tua medida, não está abrangido pelo direito de livre resolução de 14 dias.',
    erroTipo: 'Este ficheiro não é uma imagem. Usa uma foto JPG, PNG ou HEIC.',
    erroTamanho: 'A foto é maior do que {mb} MB. Escolhe uma foto mais leve.',
    erroGeral: 'Não conseguimos preparar a tua foto. Verifica a ligação e tenta de novo.',
    erroCarrinho: 'Não foi possível adicionar ao carrinho. Tenta de novo.',
    erroFormato: 'Formato não suportado. Usa uma foto JPG, PNG ou HEIC.',
    erroIlegivel: 'Não conseguimos ler esta imagem. Tenta outra foto (JPG, PNG ou HEIC).',
    erroPequena: 'A imagem é demasiado pequena. Usa uma foto com pelo menos 200 píxeis.',
    erroSemMotivo: 'Não encontrámos ninguém nesta foto. Experimenta uma foto com a pessoa ou o animal bem visível.',
    erroMotivoPequeno: 'A pessoa ou o animal aparece muito pequeno. Experimenta uma foto mais próxima.',
    erroLimite: 'Fizeste muitos pedidos seguidos. Tenta de novo daqui a pouco.',
    erroOcupado: 'Estamos com muitos pedidos neste momento. Tenta de novo dentro de um minuto.',
    tentarNovamente: 'Tentar de novo',
  },
  es: {
    titulo: 'Crea tu cojín',
    subtitulo: 'Sube una foto y mira tu cojín en 3D, con la forma de quien más quieres.',
    uploadAjuda: 'JPG, PNG o HEIC · hasta 15 MB',
    uploadBotao: 'Sube tu foto',
    uploadArrastar: 'o arrástrala aquí',
    dica: 'Consejo: elige una foto nítida, con buena luz y con la persona o el animal entero en la imagen.',
    privacidade: 'Tu foto se usa solo para crear el cojín y se elimina si no haces el pedido o en cuanto lo recibas.',
    privacidadeLink: 'Política de privacidad',
    aGerarTitulo: 'Preparando tu cojín…',
    aGerarMensagens: 'Recortando tu foto|Dibujando la forma del cojín|Añadiendo el borde blanco|Rellenándolo bien|Casi listo',
    aGerarAjuda: 'Esto puede tardar hasta 30 segundos.',
    arrastar: 'Arrastra para girar',
    medidas: 'Medidas aproximadas: {largura} × {altura} cm',
    tamanhoTitulo: 'Elige el tamaño',
    mudarImagem: 'Cambiar imagen',
    adicionar: 'Añadir al carrito',
    aAdicionar: 'Añadiendo…',
    adicionado: 'Añadido al carrito ✓',
    criarOutra: 'Crear otro cojín',
    descontoOutra: 'Añade el 2.º y ahorras un 10% en cada uno',
    desconto3: 'Añade el 3.º y ahorras un 15% en cada uno',
    desconto4: 'Añade el 4.º y ahorras un 25% en cada uno',
    verCarrinho: 'Ver carrito',
    semImagem: 'Sube una foto para continuar',
    esgotado: 'Agotado',
    aviso: 'La vista previa en 3D es orientativa. Nuestro equipo revisa cada foto antes de fabricar tu cojín.',
    prazo: 'Hecho por encargo · se envía en 3 a 4 días',
    prazoLink: 'Política de envío',
    personalizado: 'Al ser un producto personalizado, hecho a tu medida, no está sujeto al derecho de desistimiento de 14 días.',
    erroTipo: 'Este archivo no es una imagen. Usa una foto JPG, PNG o HEIC.',
    erroTamanho: 'La foto pesa más de {mb} MB. Elige una foto más ligera.',
    erroGeral: 'No hemos podido preparar tu foto. Comprueba la conexión e inténtalo de nuevo.',
    erroCarrinho: 'No se ha podido añadir al carrito. Inténtalo de nuevo.',
    erroFormato: 'Formato no compatible. Usa una foto JPG, PNG o HEIC.',
    erroIlegivel: 'No hemos podido leer esta imagen. Prueba con otra foto (JPG, PNG o HEIC).',
    erroPequena: 'La imagen es demasiado pequeña. Usa una foto de al menos 200 píxeles.',
    erroSemMotivo: 'No hemos encontrado a nadie en esta foto. Prueba con una foto en la que la persona o el animal se vea bien.',
    erroMotivoPequeno: 'La persona o el animal sale muy pequeño. Prueba con una foto más cercana.',
    erroLimite: 'Has hecho muchas solicitudes seguidas. Inténtalo de nuevo dentro de un rato.',
    erroOcupado: 'Ahora mismo tenemos muchas solicitudes. Inténtalo de nuevo en un minuto.',
    tentarNovamente: 'Intentar de nuevo',
  },
  de: {
    titulo: 'Gestalte dein Kissen',
    subtitulo: 'Lade ein Foto hoch und sieh dein Kissen in 3D – in der Form deiner Liebsten.',
    uploadAjuda: 'JPG, PNG oder HEIC · bis 15 MB',
    uploadBotao: 'Lade dein Foto hoch',
    uploadArrastar: 'oder hierher ziehen',
    dica: 'Tipp: Wähle ein scharfes, gut beleuchtetes Foto, auf dem die Person oder das Tier vollständig zu sehen ist.',
    privacidade: 'Dein Foto wird nur für dein Kissen verwendet und gelöscht, wenn du nicht bestellst oder sobald du es erhalten hast.',
    privacidadeLink: 'Datenschutzerklärung',
    aGerarTitulo: 'Dein Kissen wird vorbereitet …',
    aGerarMensagens: 'Foto wird freigestellt|Kissenform wird gezeichnet|Weißer Rand wird hinzugefügt|Kissen wird aufgeplustert|Fast fertig',
    aGerarAjuda: 'Das kann bis zu 30 Sekunden dauern.',
    arrastar: 'Zum Drehen ziehen',
    medidas: 'Ungefähre Maße: {largura} × {altura} cm',
    tamanhoTitulo: 'Wähle die Größe',
    mudarImagem: 'Bild ändern',
    adicionar: 'In den Warenkorb',
    aAdicionar: 'Wird hinzugefügt …',
    adicionado: 'In den Warenkorb gelegt ✓',
    criarOutra: 'Weiteres Kissen gestalten',
    descontoOutra: 'Mit dem 2. Kissen sparst du 10 % auf jedes',
    desconto3: 'Mit dem 3. Kissen sparst du 15 % auf jedes',
    desconto4: 'Mit dem 4. Kissen sparst du 25 % auf jedes',
    verCarrinho: 'Zum Warenkorb',
    semImagem: 'Lade ein Foto hoch, um fortzufahren',
    esgotado: 'Ausverkauft',
    aviso: 'Die 3D-Vorschau dient zur Orientierung. Unser Team prüft jedes Foto, bevor dein Kissen hergestellt wird.',
    prazo: 'Auf Bestellung gefertigt · Versand in 3 bis 4 Tagen',
    prazoLink: 'Versandbedingungen',
    personalizado: 'Da es sich um ein personalisiertes, nach deinen Vorgaben gefertigtes Produkt handelt, besteht kein 14-tägiges Widerrufsrecht.',
    erroTipo: 'Diese Datei ist kein Bild. Bitte verwende ein Foto im Format JPG, PNG oder HEIC.',
    erroTamanho: 'Das Foto ist größer als {mb} MB. Bitte wähle ein kleineres Foto.',
    erroGeral: 'Wir konnten dein Foto nicht vorbereiten. Prüfe deine Verbindung und versuche es erneut.',
    erroCarrinho: 'Das Kissen konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.',
    erroFormato: 'Dieses Format wird nicht unterstützt. Bitte verwende JPG, PNG oder HEIC.',
    erroIlegivel: 'Wir konnten dieses Bild nicht lesen. Versuche es mit einem anderen Foto (JPG, PNG oder HEIC).',
    erroPequena: 'Das Bild ist zu klein. Bitte verwende ein Foto mit mindestens 200 Pixeln.',
    erroSemMotivo: 'Auf diesem Foto konnten wir niemanden erkennen. Versuche ein Foto, auf dem die Person oder das Tier gut zu sehen ist.',
    erroMotivoPequeno: 'Die Person oder das Tier ist sehr klein. Versuche ein Foto aus kürzerer Entfernung.',
    erroLimite: 'Du hast viele Anfragen hintereinander gesendet. Bitte versuche es gleich noch einmal.',
    erroOcupado: 'Gerade gibt es sehr viele Anfragen. Bitte versuche es in einer Minute erneut.',
    tentarNovamente: 'Erneut versuchen',
  },
};

// código de erro do servidor → texto
const ERROS_SERVIDOR = {
  formato: 'erroFormato', ilegivel: 'erroIlegivel', pequena: 'erroPequena', grande: 'erroTamanho',
  sem_motivo: 'erroSemMotivo', motivo_pequeno: 'erroMotivoPequeno', limite: 'erroLimite',
  ocupado: 'erroOcupado', geral: 'erroGeral',
};

export function textosPara(lingua) {
  const base = String(lingua || 'pt').toLowerCase().slice(0, 2);
  return TEXTOS[base] || TEXTOS.pt;
}

function h(tag, atributos = {}, ...filhos) {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(atributos)) {
    if (v === false || v == null) continue;
    if (k === 'class') el.className = v;
    else if (k.startsWith('on')) el.addEventListener(k.slice(2), v);
    else el.setAttribute(k, v === true ? '' : v);
  }
  for (const f of filhos.flat()) if (f != null && f !== false) el.append(f);
  return el;
}

const ICONES = {
  foto: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="15" rx="3"/><circle cx="12" cy="12.5" r="3.5"/><path d="M8 5l1.5-2h5L16 5"/></svg>',
  trocar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12a8 8 0 0113.7-5.6L20 8.7"/><path d="M20 4v4.7h-4.7"/><path d="M20 12a8 8 0 01-13.7 5.6L4 15.3"/><path d="M4 20v-4.7h4.7"/></svg>',
  camiao: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h12v10H2z"/><path d="M14 9h4l4 4v3h-8"/><circle cx="6.5" cy="17.5" r="1.5"/><circle cx="17.5" cy="17.5" r="1.5"/></svg>',
  escudo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
  rodar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12c0-2.2 4-4 9-4s9 1.8 9 4-4 4-9 4"/><path d="M14.5 13.5L12 16l2.5 2.5"/></svg>',
};

// silhuetas brancas (PNG) das almofadas que rodam em 3D enquanto o recorte é preparado; ficam na pasta do almofada-3d.js
const FORMAS = ['cao'];

function icone(nome) {
  const s = h('span', { class: 'th-alm__icone', 'aria-hidden': 'true' });
  s.innerHTML = ICONES[nome];
  return s;
}

function formatar(texto, valores) {
  return texto.replace(/\{(\w+)\}/g, (_, k) => (k in valores ? valores[k] : `{${k}}`));
}

export function iniciar(raiz, cfgParcial) {
  if (raiz._thAlmofada) raiz._thAlmofada.destruir();
  const cfg = { ...PADRAO, ...cfgParcial };
  const T = { ...TEXTOS.pt, ...textosPara(cfg.lingua),
    ...Object.fromEntries(Object.entries(cfg.textos || {}).filter(([, v]) => v && String(v).trim())) };

  const estado = {
    fase: 'vazio',            // vazio | a-gerar | preview | erro
    resultado: null,          // resposta do servidor
    tamanho: cfg.tamanhos.find((t) => t.padrao && t.disponivel) || cfg.tamanhos.find((t) => t.disponivel)
      || cfg.tamanhos[0] || { cm: 40, disponivel: false },
    pedido: null,
    visor: null,
  };

  let modulo3d = null;
  const carregar3d = () => (modulo3d ||= import(cfg.modulo3d));
  // o motor 3D e a forma da animação de espera começam a descarregar logo, enquanto o cliente escolhe a foto
  const preCarregar = () => {
    carregar3d().catch(() => { modulo3d = null; });
    const pasta = new URL('.', new URL(cfg.modulo3d, window.location.href));
    FORMAS.forEach((f) => { new Image().src = new URL(`almofada-forma-${f}.png`, pasta).href; });
  };
  if (window.requestIdleCallback) requestIdleCallback(preCarregar, { timeout: 2500 });
  else setTimeout(preCarregar, 1200);

  /* ---------- estrutura ---------- */
  const inputFicheiro = h('input', {
    type: 'file', accept: 'image/jpeg,image/png,image/heic,image/heif,.heic,.heif,.jpg,.jpeg,.png',
    class: 'th-alm__ficheiro', tabindex: '-1', 'aria-hidden': 'true',
  });
  const palco = h('div', { class: 'th-alm__palco', 'aria-live': 'polite' });
  const titulo = h('h2', { class: 'th-alm__titulo' }, T.titulo);
  const subtitulo = h('p', { class: 'th-alm__subtitulo' }, T.subtitulo);
  const preco = h('p', { class: 'th-alm__preco' });
  const tamanhos = h('div', { class: 'th-alm__tamanhos', role: 'radiogroup', 'aria-label': T.tamanhoTitulo });
  const nomeTamanho = h('span', { class: 'th-alm__rotulo-nome' });
  const blocoTamanhos = h('div', { class: 'th-alm__bloco' },
    h('p', { class: 'th-alm__rotulo' }, T.tamanhoTitulo, nomeTamanho), tamanhos);
  const medidas = h('p', { class: 'th-alm__medidas' });
  const btnMudar = h('button', { type: 'button', class: 'th-alm__secundario', disabled: true },
    icone('trocar'), h('span', {}, T.mudarImagem));
  const btnAdicionar = h('button', { type: 'button', class: 'th-alm__cta', disabled: true }, T.semImagem);
  const raizLoja = window.Shopify?.routes?.root || '/';
  const botoesAdicionar = [btnAdicionar];
  // depois de adicionar: convite para criar outra almofada (a 2.ª tem -20%, desconto automático na loja)
  const btnOutra = h('button', { type: 'button', class: 'th-alm__secundario th-alm__outra-botao' }, icone('foto'), h('span', {}, T.criarOutra));
  const selo = h('span', { class: 'th-alm__selo' }, T.descontoOutra);
  const blocoOutra = h('div', { class: 'th-alm__outra', hidden: true }, selo, btnOutra,
    h('a', { class: 'th-alm__ver-carrinho', href: `${raizLoja}cart` }, T.verCarrinho));
  const erroCarrinho = h('p', { class: 'th-alm__erro-carrinho', role: 'alert', hidden: true });
  const prazo = cfg.diasProducao > 0
    ? h('p', { class: 'th-alm__prazo' }, icone('camiao'),
      h('span', {}, formatar(T.prazo, { dias: cfg.diasProducao }), ' · ',
        h('a', { href: `${raizLoja}policies/shipping-policy`, target: '_blank', rel: 'noopener' }, T.prazoLink)))
    : null;
  const privacidade = h('p', { class: 'th-alm__prazo th-alm__privacidade' }, icone('escudo'),
    h('span', {}, T.privacidade, ' ',
      h('a', { href: `${raizLoja}policies/privacy-policy`, target: '_blank', rel: 'noopener' }, T.privacidadeLink)));
  const aviso = h('p', { class: 'th-alm__aviso' }, T.aviso, h('br'), T.personalizado);

  const painel = h('div', { class: 'th-alm__painel' },
    preco,
    cfg.tamanhos.length > 1 ? blocoTamanhos : null,
    medidas, btnAdicionar, blocoOutra, prazo, privacidade, erroCarrinho, aviso);

  raiz.replaceChildren(h('div', { class: 'th-alm__cabecalho' }, titulo, subtitulo),
    h('div', { class: 'th-alm' }, palco, painel), inputFicheiro);

  /* ---------- tamanhos ---------- */
  function desenharTamanhos() {
    tamanhos.replaceChildren(...cfg.tamanhos.map((t) => {
      const ativo = t === estado.tamanho;
      return h('button', {
        type: 'button', role: 'radio', 'aria-checked': String(ativo),
        class: 'th-alm__pilula' + (ativo ? ' is-ativo' : ''),
        'aria-label': `${t.etiqueta} · ${t.cm} cm`,
        disabled: !t.disponivel,
        onclick: () => escolherTamanho(t),
      }, `${t.cm} cm`);
    }));
    nomeTamanho.textContent = estado.tamanho.etiqueta ? ` · ${estado.tamanho.etiqueta}` : '';
    preco.textContent = estado.tamanho.preco || '';
    preco.hidden = !estado.tamanho.preco;
  }

  function escolherTamanho(t) {
    estado.tamanho = t;
    estado.adicionado = false; // outro tamanho = pode voltar a adicionar
    desenharTamanhos();
    if (estado.visor) mostrarMedidas(estado.visor.setTamanho(t.cm));
    atualizarBotao();
  }

  function mostrarMedidas(m) {
    medidas.textContent = m ? formatar(T.medidas, { largura: m.larguraCm, altura: m.alturaCm }) : '';
    medidas.hidden = !m;
    estado.medidas = m;
  }

  function atualizarBotao() {
    const pronto = estado.fase === 'preview';
    // com a almofada à vista, o subtítulo já não é preciso (poupa altura no telemóvel)
    subtitulo.hidden = pronto;
    const disponivel = estado.tamanho.disponivel !== false;
    for (const b of botoesAdicionar) {
      b.disabled = !pronto || !disponivel || estado.adicionado;
      b.textContent = !disponivel ? T.esgotado : estado.adicionado ? T.adicionado : pronto ? T.adicionar : T.semImagem;
      b.classList.toggle('is-adicionado', !!estado.adicionado);
    }
    blocoOutra.hidden = !estado.adicionado;
    // descontos automáticos na loja, em todas as almofadas: 2 = -10% · 3 = -15% · 4 ou mais = -25%
    const n = estado.almofadasNoCarrinho || 1;
    selo.textContent = n === 1 ? T.descontoOutra : n === 2 ? T.desconto3 : T.desconto4;
    selo.hidden = n >= 4;
    btnMudar.disabled = estado.fase === 'vazio';
  }

  /* ---------- fases do palco ---------- */
  function faseVazio() {
    estado.fase = 'vazio';
    destruirVisor();
    const zona = h('div', { class: 'th-alm__zona', role: 'button', tabindex: '0' },
      h('div', { class: 'th-alm__zona-ilustracao' }, icone('foto')),
      h('span', { class: 'th-alm__cta th-alm__cta--pequeno' }, T.uploadBotao),
      h('p', { class: 'th-alm__zona-ajuda' }, T.uploadArrastar),
      h('p', { class: 'th-alm__zona-ajuda th-alm__zona-formatos' }, T.uploadAjuda));
    zona.addEventListener('click', abrirSeletor);
    zona.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrirSeletor(); } });
    zona.addEventListener('pointerenter', carregar3d, { once: true });
    zona.addEventListener('dragover', (e) => { e.preventDefault(); zona.classList.add('is-arrastar'); });
    zona.addEventListener('dragleave', () => zona.classList.remove('is-arrastar'));
    zona.addEventListener('drop', (e) => {
      e.preventDefault();
      zona.classList.remove('is-arrastar');
      const f = e.dataTransfer?.files?.[0];
      if (f) receberFicheiro(f);
    });
    palco.replaceChildren(zona, h('p', { class: 'th-alm__dica' }, T.dica));
    atualizarBotao();
  }

  function faseAGerar() {
    estado.fase = 'a-gerar';
    destruirVisor();
    // almofadas brancas em 3D a rodar enquanto se prepara o recorte (pessoa, cão, casal, gato, carro);
    // o mesmo visor mostra depois a almofada do cliente, no mesmo sítio
    const tela = h('div', { class: 'th-alm__tela' });
    estado.tela = tela;
    const mensagens = T.aGerarMensagens.split('|').map((s) => s.trim()).filter(Boolean);
    const msg = h('p', { class: 'th-alm__gerar-msg' }, mensagens[0] || '');
    const barra = h('div', { class: 'th-alm__barra-progresso' });
    palco.replaceChildren(tela, h('div', { class: 'th-alm__gerar' },
      h('p', { class: 'th-alm__gerar-titulo' }, T.aGerarTitulo),
      msg,
      h('div', { class: 'th-alm__barra', role: 'progressbar', 'aria-label': T.aGerarTitulo }, barra),
      h('p', { class: 'th-alm__zona-ajuda' }, T.aGerarAjuda)));

    carregar3d().then(({ Almofada3D }) => {
      if (estado.fase !== 'a-gerar' || estado.tela !== tela) return;
      estado.visor = new Almofada3D(tela, { margemCm: cfg.margemCm });
      const pasta = new URL('.', new URL(cfg.modulo3d, window.location.href));
      estado.visor.modoEspera(FORMAS.map((f) => new URL(`almofada-forma-${f}.png`, pasta).href));
    }).catch((e) => console.warn('[almofada] sem animação 3D', e));

    const inicio = performance.now();
    let i = 0;
    const temporizador = setInterval(() => {
      const s = (performance.now() - inicio) / 1000;
      // avança depressa no início e abranda até ~92 %
      barra.style.width = `${Math.min(92, 100 * (1 - Math.exp(-s / 11)))}%`;
      const novo = Math.min(Math.floor(s / 3.2), mensagens.length - 1);
      if (novo !== i) { i = novo; msg.textContent = mensagens[i]; }
    }, 200);
    estado.pararAnimacao = () => clearInterval(temporizador);
    atualizarBotao();
  }

  async function fasePreview(resultado) {
    estado.pararAnimacao?.();
    const { Almofada3D } = await carregar3d();
    // reaproveita o visor da animação de espera (a almofada aparece no mesmo sítio)
    let tela = estado.visor && estado.tela;
    if (!tela) {
      destruirVisor();
      tela = h('div', { class: 'th-alm__tela' });
      estado.tela = tela;
      estado.visor = new Almofada3D(tela, { margemCm: cfg.margemCm });
    }
    palco.replaceChildren(
      tela,
      h('div', { class: 'th-alm__barra-ferramentas' },
        h('p', { class: 'th-alm__arrastar' }, icone('rodar'), T.arrastar),
        h('div', { class: 'th-alm__botoes-palco' }, btnMudar)));

    const m = await estado.visor.setImagem(resultado.preview || resultado.recorte_url, estado.tamanho.cm);
    estado.fase = 'preview';
    estado.resultado = resultado;
    mostrarMedidas(m);
    atualizarBotao();
  }

  function faseErro(mensagem) {
    estado.pararAnimacao?.();
    estado.fase = 'erro';
    destruirVisor();
    palco.replaceChildren(h('div', { class: 'th-alm__erro', role: 'alert' },
      h('p', {}, mensagem),
      h('button', { type: 'button', class: 'th-alm__cta th-alm__cta--pequeno', onclick: abrirSeletor }, T.tentarNovamente)));
    mostrarMedidas(null);
    atualizarBotao();
  }

  function destruirVisor() {
    estado.visor?.dispose();
    estado.visor = null;
    estado.tela = null;
  }

  /* ---------- upload ---------- */
  function abrirSeletor() {
    inputFicheiro.value = '';
    inputFicheiro.click();
  }

  inputFicheiro.addEventListener('change', () => {
    const f = inputFicheiro.files?.[0];
    if (f) receberFicheiro(f);
  });

  async function receberFicheiro(ficheiro) {
    const tipoOk = /^image\//.test(ficheiro.type) || /\.(heic|heif|jpe?g|png)$/i.test(ficheiro.name);
    if (!tipoOk) return faseErro(T.erroTipo);
    if (ficheiro.size > cfg.maxMb * 1024 * 1024) return faseErro(formatar(T.erroTamanho, { mb: cfg.maxMb }));

    estado.adicionado = false;
    estado.pedido?.abort();
    const pedido = new AbortController();
    estado.pedido = pedido;
    estado.resultado = null;
    faseAGerar();
    carregar3d();

    try {
      let resultado;
      if (cfg.processarLocalmente) {
        resultado = await cfg.processarLocalmente(ficheiro);
      } else {
        const dados = new FormData();
        dados.append('imagem', ficheiro, ficheiro.name || 'foto.jpg');
        const r = await fetch(`${cfg.servidor.replace(/\/$/, '')}/remove-bg`, {
          method: 'POST', body: dados, signal: pedido.signal,
        });
        const corpo = await r.json().catch(() => ({}));
        if (!r.ok) {
          const chave = ERROS_SERVIDOR[corpo.codigo] || 'erroGeral';
          throw Object.assign(new Error(formatar(T[chave], { mb: cfg.maxMb })), { mostrar: true });
        }
        resultado = corpo;
      }
      if (pedido.signal.aborted) return;
      await fasePreview(resultado);
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error('[almofada]', e);
      faseErro(e.mostrar ? e.message : T.erroGeral);
    }
  }

  btnMudar.addEventListener('click', abrirSeletor);

  /* ---------- carrinho ---------- */
  async function adicionar() {
    if (estado.fase !== 'preview') return;
    const propriedades = {
      _imagem_original: estado.resultado.original_url,
      _recorte: estado.resultado.recorte_url,
      _tamanho_cm: String(estado.tamanho.cm),
    };
    if (estado.medidas) propriedades._medidas = `${estado.medidas.larguraCm} × ${estado.medidas.alturaCm} cm`;
    const item = { id: estado.tamanho.varianteId, quantity: 1, properties: propriedades };

    if (cfg.modoTeste) {
      cfg.aoAdicionarTeste?.(item);
      estado.almofadasNoCarrinho = (estado.almofadasNoCarrinho || 0) + 1;
      estado.adicionado = true;
      atualizarBotao();
      return;
    }

    for (const b of botoesAdicionar) { b.disabled = true; b.textContent = T.aAdicionar; }
    erroCarrinho.hidden = true;
    // imagem da almofada 3D para o carrinho (se falhar, o carrinho mostra a foto do produto)
    try {
      const blob = await estado.visor?.capturaBlob();
      if (blob) {
        const dados = new FormData();
        dados.append('recorte_url', estado.resultado.recorte_url);
        dados.append('imagem', blob, 'almofada.png');
        const r = await fetch(`${cfg.servidor.replace(/\/$/, '')}/preview-carrinho`, { method: 'POST', body: dados });
        if (r.ok) item.properties._preview = (await r.json()).preview_url;
      }
    } catch (e) { console.warn('[almofada] sem imagem para o carrinho', e); }
    const gaveta = cfg.depoisDeAdicionar !== 'carrinho' ? document.querySelector('cart-drawer') : null;
    try {
      const corpo = { items: [item] };
      if (gaveta?.renderContents) {
        corpo.sections = gaveta.getSectionsToRender().map((s) => s.id);
        corpo.sections_url = window.location.pathname;
      }
      const r = await fetch(`${raizLoja}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo),
      });
      const resposta = await r.json();
      if (!r.ok) throw new Error(resposta.description || resposta.message || T.erroCarrinho);

      if (cfg.depoisDeAdicionar === 'carrinho' || (cfg.depoisDeAdicionar === 'gaveta' && !gaveta?.renderContents)) {
        window.location.href = `${raizLoja}cart`;
        return;
      }
      if (cfg.depoisDeAdicionar === 'gaveta' && gaveta?.renderContents) {
        gaveta.classList.remove('is-empty');
        gaveta.renderContents({ ...resposta, id: resposta.items?.[0]?.id ?? item.id });
      } else if (gaveta?.getSectionsToRender && resposta.sections) {
        // fica na página: atualiza o ícone do carrinho e a gaveta sem a abrir
        try {
          gaveta.classList.remove('is-empty');
          for (const s of gaveta.getSectionsToRender()) {
            // igual ao renderContents do tema (Dawn): o seletor indica o elemento a substituir
            const alvo = s.selector ? document.querySelector(s.selector) : document.getElementById(s.section || s.id);
            const html = resposta.sections[s.id];
            if (!alvo || !html) continue;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fonte = doc.querySelector(s.selector || '.shopify-section') || doc.body;
            alvo.innerHTML = fonte.innerHTML;
          }
        } catch (e) { console.warn('[almofada] não foi possível atualizar o carrinho', e); }
      }
      document.dispatchEvent(new CustomEvent('th:almofada:adicionada', { detail: resposta }));
      try {
        const carrinho = await fetch(`${raizLoja}cart.js`).then((x) => x.json());
        estado.almofadasNoCarrinho = carrinho.items
          .filter((i) => i.properties?._recorte).reduce((t, i) => t + i.quantity, 0);
      } catch { estado.almofadasNoCarrinho = 1; }
      estado.adicionado = true;
      atualizarBotao();
    } catch (e) {
      erroCarrinho.textContent = e.message || T.erroCarrinho;
      erroCarrinho.hidden = false;
      atualizarBotao();
    }
  }
  for (const b of botoesAdicionar) b.addEventListener('click', adicionar);

  btnOutra.addEventListener('click', () => {
    estado.adicionado = false;
    estado.resultado = null;
    faseVazio();
    raiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    abrirSeletor();
  });

  desenharTamanhos();
  faseVazio();

  const api = {
    destruir() { estado.pedido?.abort(); estado.pararAnimacao?.(); destruirVisor(); raiz._thAlmofada = null; },
    estado,
  };
  raiz._thAlmofada = api;
  return api;
}

export function iniciarTodos(contexto = document) {
  contexto.querySelectorAll('[data-th-almofada]').forEach((raiz) => {
    const json = raiz.querySelector('script[type="application/json"]');
    if (!json) return;
    try {
      iniciar(raiz, JSON.parse(json.textContent));
    } catch (e) {
      console.error('[almofada] configuração inválida', e);
    }
  });
}

if (!window.__thAlmofadaManual) {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => iniciarTodos());
  else iniciarTodos();
  // editor de temas: volta a iniciar quando a secção é alterada
  document.addEventListener('shopify:section:load', (e) => iniciarTodos(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-th-almofada]').forEach((r) => r._thAlmofada?.destruir());
  });
}
